<template>
	<div
		class="popup-container"
		:class="{
			'popup-fullscreen': isFullScreen,
		}"
		@click="(e) => e.stopPropagation()"
	>
		<div
			role="button"
			class="popup-button"
			@click="open"
		>
			<slot name="trigger" />
		</div>

		<div
			v-if="isOpen"
			class="popup"
		>
			<div class="popup-content">
				<slot
					name="content"
					:close="close"
				/>
			</div>

			<button
				v-if="!hideClose"
				class="popup-close"
				@click="close"
			>
				&times;
			</button>
		</div>
	</div>
</template>

<script lang="ts">
import { defineComponent, type SlotsType } from 'vue';

export default defineComponent({
	props: {
		isFullScreen: {
			type: Boolean,
			default: false,
		},
		hideClose: {
			type: Boolean,
			default: false,
		},
	},
	emits: ['close'],
	data() {
		return {
			isOpen: false,
		};
	},
	slots: Object as SlotsType<{
		content: {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
			close: Function;
		};
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		trigger: any;
	}>,
	methods: {
		open() {
			this.isOpen = true;
			document.addEventListener('click', this.handleDocClick);
			document.addEventListener('keydown', this.handleKeyPress);
		},
		close() {
			document.removeEventListener('click', this.handleDocClick);
			document.removeEventListener('keydown', this.handleKeyPress);

			this.isOpen = false;
			this.$emit('close');
		},
		handleDocClick() {
			if (!this.isOpen) {
				// shouldn't ever be able to get here really
				return;
			}

			this.close();
		},
		handleKeyPress(evt: KeyboardEvent) {
			if (!(evt.key === 'Escape' || evt.key === 'Esc')) {
				return;
			}

			this.close();
		},
	},
});
</script>

<style scoped lang="scss">
.popup-container {
	position: relative;

	.popup {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 99999;
		box-shadow: rgb(0 0 0 / 24%) 0 3px 8px;
		border-radius: var(--rs-border-radius);
		background-color: white;
		padding: var(--rs-layout-content-padding);

		.popup-content {
			min-width: clamp(200px, 350px, 80vw);
		}

		.popup-close {
			display: flex;
			position: absolute;
			top: 0;
			right: 0;
			justify-content: center;
			align-items: center;
			width: 20px;
			height: 20px;
			font-size: 20px;
		}
	}

	&.popup-fullscreen {
		.popup {
			position: fixed;
			right: 0;
			bottom: 0;
			border-radius: 0;
			background-color: rgba(0 0 0 / 66%);
			padding: 20px;
			overflow: scroll;

			.popup-content {
				background-color: white;
				padding: 20px;
			}
		}
	}
}
</style>
